// FullFunctional.jsx
import { Row, Col } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Sort } from '../../Component/Component'
import SearchBlock from '../../Component/SearchBlock'


const FullFunctional = ({
    additionalData,
    noneSelectUpdatedPictures,
    setUpdatedPictures,
    setSortReducer,
    setSortSearch,
    sortSearch,
    dispatchAction,
    setSearchMainName,
    updatedPictures,
    valueTabsSort,
    setPageNumber,
    setPageSize,
    productSort,
    hideMarked,
    pageNumber,
    sortItems,
    typeSort,
    sortType,
    pageSize,
    getSlug,
    showAll,
    search,
    slug,
    view,
    get,
}) => {

    return (
        <>
            <div className="disk">
                <SearchBlock
                    sortSearch={sortSearch}
                    setSortSearch={setSortSearch}
                    search={search}
                    setSearchMainName={setSearchMainName}
                    sortType={sortType}
                    productSort={productSort}
                    get={get}
                />
            </div>
            <Sort
                noneSelectUpdatedPictures={noneSelectUpdatedPictures}
                additionalData={additionalData}
                sortType={sortType}
                setSortReducer={setSortReducer}
                dispatchAction={dispatchAction}
                valueTabsSort={valueTabsSort}
                productSort={productSort ? productSort : null}
                setUpdatedPictures={setUpdatedPictures}
                updatedPictures={updatedPictures}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                hideMarked={hideMarked}
                pageNumber={pageNumber}
                get={get ? get : null}
                sortItems={sortItems}
                typeSort={typeSort}
                pageSize={pageSize}
                getSlug={getSlug}
                showAll={showAll}
                slug={slug}
            />
        </>
    )
}

export default FullFunctional